import * as React from 'react'
import { Button } from '~/components/_atoms/index'
import Spinner from '~/components/shared/Spinner'
import { useTranslation } from '~/hooks/useTranslation'
import { getApi } from '~/util/api'

export function EmailCell({ row, table }) {
  const chat = row.original
  const { t } = useTranslation()
  const [isEmailing, setIsEmailing] = React.useState(false)
  const chatId = chat.id
  const toast = table.options.meta?.toast

  const handleEmailChat = async () => {
    setIsEmailing(true)
    try {
      const response = await getApi().post(
        `/chat_histories/${chatId}/email_chat_conversation`,
      )
      if (response.data.success) {
        toast({ description: response.data.message })
      }
    } catch (error) {
      console.error('Error emailing chat conversation:', error)
      toast({
        description: t('chat_histories.failed_to_email_chat'),
      })
    } finally {
      setIsEmailing(false)
    }
  }

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="flex flex-row items-center gap-1 text-sm">
        <div className="flex flex-col">
          <Button
            variant="link"
            onClick={() => handleEmailChat()}
            disabled={isEmailing}
          >
            <div className="flex items-center gap-2">
              {t('chat_histories.email')}
              {isEmailing && <Spinner show className="h-4 w-4" />}
            </div>
          </Button>
        </div>
      </div>
    </div>
  )
}
